import { useEffect, useState } from 'react';
import { Monitor, Download } from 'lucide-react';
import api from '../lib/api';
import { useAuth } from '../contexts/AuthContext';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

const ALLOWED = ['super_admin', 'admin', 'inventory_manager', 'platform_owner'];
const API_URL = process.env.REACT_APP_BACKEND_URL;

export const DesktopAppCard = () => {
  const { user } = useAuth();
  const [info, setInfo] = useState(null);
  const allowed = ALLOWED.includes(user?.role) && !window.pharmxai;

  useEffect(() => {
    if (!allowed) return;
    api.get('/desktop-app/latest').then(({ data }) => setInfo(data)).catch(() => setInfo(null));
  }, [allowed]);

  if (!allowed || !info?.available) return null;
  const sizeMb = Math.round((info.size || 0) / 1024 / 1024);

  return (
    <Card data-testid="desktop-app-card" className="border-primary/30 bg-primary/5">
      <CardContent className="flex flex-col sm:flex-row sm:items-center gap-4 p-4">
        <div className="h-11 w-11 rounded-xl bg-primary/10 flex items-center justify-center shrink-0">
          <Monitor className="h-5 w-5 text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-semibold text-sm">DutiLyne for Windows</p>
          <p className="text-xs text-muted-foreground mt-0.5" data-testid="desktop-app-meta">
            Version {info.version} · {sizeMb} MB · Keeps the till selling when the internet drops.
            If Windows warns "protected your PC", tap More info → Run anyway.
          </p>
        </div>
        <Button asChild className="gap-2 shrink-0" data-testid="desktop-app-download-btn">
          <a href={`${API_URL}/api/desktop-app/download`} download>
            <Download className="h-4 w-4" /> Get the desktop app
          </a>
        </Button>
      </CardContent>
    </Card>
  );
};
